import * as React from 'react'

import { Heading } from '../../heading'

interface IHeadingRendererProps {
  children?: React.ReactNode
  level?: number
}

export default function HeadingRenderer({ children, level }: IHeadingRendererProps) {
  switch (level) {
    case 1:
      return <Heading level="h1">{children}</Heading>
    case 2:
      return <Heading level="h2">{children}</Heading>
    case 3:
      return <Heading level="h3">{children}</Heading>
    case 4:
      return <Heading level="h4">{children}</Heading>
    case 5:
      return <Heading level="h5">{children}</Heading>
    case 6:
      return <Heading level="h6">{children}</Heading>
    default:
      return <>{children}</>
  }
}
